import { render } from "./trending.vue?vue&type=template&id=6d454832&scoped=true"
import script from "./trending.vue?vue&type=script&lang=js"
export * from "./trending.vue?vue&type=script&lang=js"

import "./trending.vue?vue&type=style&index=0&id=6d454832&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1941686567/src/amplify-vue-poc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d454832"]])

export default __exports__